module.exports = __webpack_public_path__ + "img/44780f47211a8f8661af2783d584bf3@2x.11e98f4e.png";